import { scope, vector } from '../instructions';
import { DateFieldIndex, DateFieldWidthIndex, RelativeTimeFieldIndex } from '../schema';
var prevNext = ['previous2', 'previous', 'current', 'next', 'next2'].map(function (k) {
    return vector(k, ['relative-time-field']);
});
var futurePast = ['future', 'past'].map(function (k) { return vector(k, ['plural-key', 'relative-time-field']); });
var relativeTimeBody = prevNext.concat(futurePast);
var relativeTimes = function (width) { return scope(width, width, relativeTimeBody); };
export var DATEFIELDS = scope('DateFields', 'DateFields', [
    scope('relativeTimes', 'relativeTimes', [relativeTimes('wide'), relativeTimes('short'), relativeTimes('narrow')]),
    vector('displayName', ['date-field', 'date-field-width']),
]);
export var DATEFIELDS_INDICES = {
    'date-field': DateFieldIndex,
    'date-field-width': DateFieldWidthIndex,
    'relative-time-field': RelativeTimeFieldIndex,
};
//# sourceMappingURL=datefields.js.map